import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageKnowledgeBase = lazy(() => import("./layout/index"));

export const routerPageKnowledgeBase: RouterItemType = {
  path: "/support/kb",
  authorize: false,
  element: <LayoutPageKnowledgeBase />,
};
